import {registerReactPartial} from '@github-ui/react-core/register-partial'

import {CopilotChat} from './CopilotChat'

registerReactPartial('copilot-chat', {
  Component: CopilotChat,
})
